import { useQuery } from 'react-query';
import { GET_WORKSPACE_PROFILE } from 'Services/apiKeys';
import { getWorkspaceProfile } from 'Services/apiFunctions';

/**
 * Shared `GET workspace/profile` query (one cache entry for the module guard, the choose-action tab and intros).
 * staleTime stops the page mounting under the guard from refetching it. No retry: the guard waits on this, so a failure must settle (and fail open) quickly. Disabled without a token.
 */
export const useWorkspaceProfile = (token, options = {}) =>
    useQuery([GET_WORKSPACE_PROFILE, token], getWorkspaceProfile, {
        enabled: !!token,
        retry: 0,
        staleTime: 60 * 1000,
        retryOnMount: false,
        refetchOnReconnect: false,
        refetchOnWindowFocus: false,
        ...options,
    });
